// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { Avatar, IconButton, styled, Tooltip, Typography } from '@mui/material';
import {
  AiOutlinePlusCircle,
  AiOutlineCheckCircle,
  AiFillCheckCircle,
} from 'react-icons/ai';
import Link from 'next/link';
import { isEmpty, trim } from 'lodash-es';
import FollowNonProfitButton from '@/components/Buttons/FollowNonProfitButton';
import { isFollowingNonProfit } from 'stores/userActions';
import OrgType from '@/constants/orgType.constant';

const getNonProfitLocation = (nonProfit) => {
  const location = [];
  if (nonProfit.city) location.push(nonProfit.city);
  else if (nonProfit.state) location.push(nonProfit.state);
  if (nonProfit.country) location.push(nonProfit.country);
  return location.join(', ');
};

function NpoItem({
  user,
  nonProfit,
  addNonProfit,
  discardNonProfit,
  companyFollowing = false,
}) {
  const activeCommunity = user?.activeCommunity;
  const isCompanyCommunity =
    activeCommunity && activeCommunity.orgType === OrgType.Business;

  const [selected, setSelected] = useState(false);

  const handleSelected = (isSelected) => {
    setSelected(isSelected);
    if (isSelected) addNonProfit(nonProfit);
    else discardNonProfit(nonProfit);
  };

  useEffect(() => {
    const following = isFollowingNonProfit();
    setSelected(following);
  }, []);

  if (!nonProfit) {
    return null;
  }

  return (
    <div className="flex cursor-pointer items-center justify-between rounded border border-gray-100 p-2 group-hover:border-gray-200">
      <Link href={nonProfit.website_url || ''} passHref>
        <div className="flex items-center gap-4">
          <div className="shrink-0 grow-0">
            <Avatar src={nonProfit.logo_url} alt={nonProfit.name} size="sm" />
          </div>
          <div className="flex flex-1 flex-col items-start justify-between">
            <Typography
              variant="subtitle1"
              className="line-clamp-1 overflow-ellipsis font-semibold text-text-primary group-hover:text-text-hyperlink">
              {nonProfit.name}
            </Typography>
            <Typography
              variant="body1"
              color="textSecondary"
              className="line-clamp-1 overflow-ellipsis">
              {getNonProfitLocation(nonProfit)}
            </Typography>
            {companyFollowing && (
              <Typography
                variant="body1"
                color="textSecondary"
                className="line-clamp-1 overflow-ellipsis italic">
                Followed by {isCompanyCommunity ? 'Organization' : 'Community'}{' '}
              </Typography>
            )}
          </div>
        </div>
      </Link>

      {!companyFollowing && (
        <FollowNonProfitButton nonProfit={nonProfit} noConfirmation />
      )}
    </div>
  );
}

export default NpoItem;
